import { render, staticRenderFns } from "./ghlc.vue?vue&type=template&id=d4e6c38e&scoped=true"
import script from "./ghlc.vue?vue&type=script&lang=js"
export * from "./ghlc.vue?vue&type=script&lang=js"
import style0 from "./ghlc.vue?vue&type=style&index=0&id=d4e6c38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e6c38e",
  null
  
)

export default component.exports